<h2 mat-dialog-title class="d-flex justify-content-between align-items-center">
    <span>{{ guide?.title || 'Loading...' }}</span>
    <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</h2>

<mat-dialog-content class="guide-view-content">
    <div *ngIf="loading" class="text-center py-5">
        <mat-spinner diameter="40" class="mx-auto"></mat-spinner>
    </div>

    <div *ngIf="!loading && guide" id="guide-content" class="markdown-body">
        <markdown [data]="guide.content"></markdown>
    </div>

    <div *ngIf="!loading && !guide" class="text-center py-5 text-muted">
        Failed to load guide.
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button *ngIf="!readOnly" mat-raised-button color="primary" (click)="onEdit()" [disabled]="!guide">
        <mat-icon>edit</mat-icon> Edit
    </button>
    <button mat-raised-button (click)="downloadPdf()" [disabled]="!guide">
        <mat-icon>picture_as_pdf</mat-icon> Download PDF
    </button>
    <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>
